import isEmpty from 'lodash/isEmpty';
import React from 'react';
import ReactPlayer from 'react-player';
import { APP_IMG } from 'src/constants';
import { convertDatasets } from 'src/utils/datasets';
// import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';
// getFeatureImage(article)
function SectionTwo({ data }: any) {
  if (isEmpty(data?.dataSet)) return null;
  return (
    <SectionWrapper className='section-two'>
      <div className='content container'>
        <div className='initial-text'>
          <img className='title-image' src={convertDatasets(data?.dataSet, 'left-image', true)} />
          <div className='text text-excerpt-4'>{convertDatasets(data?.dataSet, 'right-text', true)}</div>
        </div>
        <div className='video'>
          <ReactPlayer width='100%' height='100%' url={convertDatasets(data?.dataSet, 'videoUrl', true) || '#'} controls={true} />
        </div>
        <div className='content-text'>
          <div className='text-1'>
            <b>กรอบ</b> <br /> การพูดคุย
          </div>
          <div className='text-2'>
            วัฒนธรรม "ชนแก้ว" ที่เดินเคียงคู่
            <br /> คติความเชื่อ วิธีคิด และวิถีชีวิตของผู้คน <br /> <br /> สิทธิ เสรีภาพ กับเรื่องก้นแก้ว
          </div>
          <div className='text-3'>
            <b>โอกาส และความท้าทาย</b>
            <br /> ของคนบ่มเหล้า/เบียร์
          </div>
        </div>
        {/* absolute */}
        <img className='asset-1' src={`${APP_IMG}/images/hangover/section-2-image.jpg`} />
        <img className='asset-2' src={`${APP_IMG}/images/hangover/section-2-image-2.jpg`} />
        <img className='ball-1' src={`${APP_IMG}/images/hangover/section-2-asset.png`} />
        <img className='ball-2' src={`${APP_IMG}/images/hangover/section-2-asset.png`} />
        <img className='ball-3' src={`${APP_IMG}/images/hangover/section-2-asset.png`} />
      </div>
    </SectionWrapper>
  );
}

const SectionWrapper = styled.div`
  position: relative;
  /* background-color: red; */
  width: 100%;
  margin: auto;
  height: auto;
  padding: 30px 0;
  padding-bottom: 0;
  @media (max-width: 767px) {
    padding: 30px 10px;
  }
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 100px;
    padding-bottom: 100px;
    @media (max-width: 992px) {
      padding: 0 15px;
      padding-bottom: 100px;
    }
    @media (max-width: 767px) {
      padding-bottom: 0;
    }
    &:before {
      content: '';
      position: absolute;
      width: 350px;
      height: 650px;
      background-color: #ea1b3c;
      right: 0;
      bottom: 0;
      z-index: -1;
      @media (max-width: 992px) {
        width: 35vw;
        height: 450px;
      }
      @media (max-width: 767px) {
        height: 330px;
      }
      @media (max-width: 767px) {
        height: 300px;
      }
    }
    .initial-text {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: start;
      @media (max-width: 767px) {
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }
      .title-image {
        width: 40%;
        @media (max-width: 767px) {
          width: 100%;
        }
      }
      .text {
        width: 50%;
        text-align: start;
        font-size: 22px;
        font-weight: 400;
        line-height: 1.3;
        @media (max-width: 767px) {
          width: 100%;
          font-size: 16px;
        }
      }
    }
    .video {
      width: 60%;
      height: auto;
      margin-bottom: 80px;
      position: relative;
      aspect-ratio: 16/9;
      @media (max-width: 992px) {
        width: 100%;
        /* height: 200px; */
        margin-bottom: 0;
      }
    }
    .content-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 60%;
      gap: 50px;
      @media (max-width: 767px) {
        width: 100%;
        padding-bottom: 66px;
        gap: 30px;
      }
      .text-1 {
        line-height: 0.7;
        b {
          font-size: 96px;
          font-weight: bolder;
          @media (max-width: 1100px) {
            font-size: 70px;
          }
          @media (max-width: 767px) {
            font-size: 50px;
          }
        }
        font-size: 38px;
        font-weight: 600;
        @media (max-width: 1100px) {
          font-size: 28px;
        }
        @media (max-width: 767px) {
          font-size: 20px;
        }
      }
      .text-2 {
        font-size: 32px;
        line-height: 1.3;
        @media (max-width: 1100px) {
          font-size: 24px;
        }
        @media (max-width: 767px) {
          font-size: 16px;
        }
        @media (max-width: 400px) {
          font-size: 12px;
        }
      }
      .text-3 {
        b {
          font-weight: bolder;
        }
        line-height: 1.3;
        font-size: 32px;
        @media (max-width: 1100px) {
          font-size: 24px;
        }
        @media (max-width: 767px) {
          font-size: 16px;
        }
        @media (max-width: 400px) {
          font-size: 12px;
        }
      }
    }
    .ball-1 {
      position: absolute;
      right: 0;
      top: 5%;
      z-index: -1;
      width: 50%;
    }
    .ball-2 {
      position: absolute;
      left: 0;
      top: 17%;
      z-index: -1;
      width: 40%;
    }
    .ball-3 {
      position: absolute;
      left: 40%;
      bottom: 0;
      z-index: -2;
      width: 40%;
      transform: scaleY(-1) translate(-50%, 0);
      @media (max-width: 767px) {
        left: 30%;
        width: 60%;
      }
    }
    .asset-1 {
      position: absolute;
      left: 0;
      bottom: 0;
      height: auto;
      width: 19%;
      max-height: 650px;
      @media (max-width: 767px) {
        display: none;
      }
    }
    .asset-2 {
      position: absolute;
      right: 17%;
      bottom: 15%;
      width: 20%;
      z-index: -1;
      @media (max-width: 767px) {
        width: 30%;
        bottom: 4%;
      }
    }
  }
`;
export default SectionTwo;
